export default __webpack_public_path__ + "static/media/ExpressJS.14d469fd.png";